export default "__VITE_ASSET__DPlXklZw__"